export const weightConstants = {
  GET_SINGLE_REQUEST: "WEIGHT_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "WEIGHT_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "WEIGHT_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "WEIGHT_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "WEIGHT_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "WEIGHT_GET_ALL_FAILURE",

  ADD_REQUEST: "WEIGHT_ADD_REQUEST",
  ADD_SUCCESS: "WEIGHT_ADD_SUCCESS",
  ADD_FAILURE: "WEIGHT_ADD_FAILURE",

  UPDATE_REQUEST: "WEIGHT_UPDATE_REQUEST",
  UPDATE_SUCCESS: "WEIGHT_UPDATE_SUCCESS",
  UPDATE_FAILURE: "WEIGHT_UPDATE_FAILURE",

  DELETE_REQUEST: "WEIGHT_DELETE_REQUEST",
  DELETE_SUCCESS: "WEIGHT_DELETE_SUCCESS",
  DELETE_FAILURE: "WEIGHT_DELETE_FAILURE",

  CLEAR: "WEIGHT_CLEAR",
};
